import React from 'react'
import { useParams } from 'react-router-dom'
import AdminPage from '../../../admin/shared/AdminPage'
import Loading from '../../../../molecules/Loading'
import { dataCatalog } from '../../../../../api/coreData'
import EmptySection from '../../../../atoms/EmptySection'
import TableDetails from './TableDetails'
import ApiDetails from './ApiDetails'

function DataSourceDetails () {
  const { datasourceId } = useParams()
  const { data, isLoading } = dataCatalog.useGetCatalogDataSource(datasourceId)

  if (isLoading) {
    return (
      <AdminPage>
        <Loading />
      </AdminPage>
    )
  }

  if (!data?.datasource) {
    return (
      <AdminPage>
        <EmptySection title='Not Available' description='' />
      </AdminPage>
    )
  }

  const datasource = data?.datasource

  return (
    <AdminPage key='data-source-details-main'>
      {datasource?.type === 'table' ? (
        <TableDetails datasource={datasource} />
      ) : (
        <ApiDetails datasource={datasource} />
      )}
    </AdminPage>
  )
}

DataSourceDetails.propTypes = {
}

export default DataSourceDetails
